import React from 'react'

import './TipStyles.less'

const TipBlock = ({children}) => (
  <span className='TipBlock'>{children}</span>
)

export default TipBlock
